import { CampaignTypes, DeviceTypes, seasonalityCampaignTypeFromODataValue } from './scope-types';
import { SeasonalitySchema } from './seasonality-schema';
import { DataExclusionSchema } from './data-exclusions-schema';
import { InlineEdit } from './inline-edit';
import { columnChooser } from './column-chooser';

export const i18nMap = {
  CampaignTypes,
  DeviceTypes,
  SeasonalitySchema,
  InlineEdit,
  seasonalityCampaignTypeFromODataValue,
  columnChooser,
  DataExclusionSchema,
};

export function safeGetString(i18n, map, key, defaultStmt) {
  const englishString = map[key];

  if (!englishString) {
    // TODO: log error to kusto
    if (!defaultStmt) {
      return key;
    }
    return i18n.getString(defaultStmt);
  }

  return i18n.getString(englishString);
}
